import { gql } from '@apollo/client';

export const GET_RESOURCE_LIBRARY_ITEM_TYPE_QUERY = gql`
    query getResourceLibraryItemType($id: Int!) {
        asset: getResourceLibraryItem(id: $id) {
            id
            classname
        }
        article: getResourceLibraryArticleItem(id: $id) {
            id
            classname
        }
        news: getResourceLibraryNewsItem(id: $id) {
            id
            classname
        }
        newProductIntroduction: getResourceLibraryNewProductIntroductionItem(id: $id) {
            id
            classname
        }
        sitePage: getResourceLibrarySitePageItem(id: $id) {
            id
            classname
        }
    }
`;

export function getResourceLibraryItemQueryVariables(id: number) {
    return {
        id: id,
    };
}
